<script setup>
defineProps({
  content: {
    type: Object,
    required: true,
    default() {
      return {}
    },
  },

  breadcrumbs: {
    type: Array,
    required: false,
    default() {
      return []
    },
  },
})
</script>

<template>
  <section
    class="relative"
    :class="{
      'flex flex-col': content.__component === 'sections.hero-plans',
      'bg-primary text-gray-700': content.style === 'Primary',
      'bg-secondary text-gray-100': content.style === 'Secondary',
      'bg-gray-100 text-gray-700': content.style === 'Tertiary',
    }"
  >
    <BaseContent
      :content="content?.children"
      grouped
      :breadcrumbs="breadcrumbs"
    />
  </section>
</template>
